import moment from 'moment';
import React from 'react';
import PropTypes from 'prop-types';
import { Col, Container, Row } from 'reactstrap';
import VersionDisplay from '../common/infoDisplays/versionDisplay';
import entityComposition from '../common/classes/entityComposition';
const Footer = props => {
  const _props$login = props.login,
    customer = _props$login.customer,
    user = _props$login.user;
  return /*#__PURE__*/React.createElement("div", {
    className: "card-footer small fixed-bottom"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, {
    xs: 4
  }, "\xA9 ", moment().format('YYYY'), " TRU"), /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    style: {
      textAlign: 'center'
    }
  }, customer, " ", user && "> ".concat(user.username)), /*#__PURE__*/React.createElement(Col, {
    xs: 4,
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(VersionDisplay, null)))));
};
Footer.propTypes = {
  login: PropTypes.shape({
    customer: PropTypes.string,
    user: PropTypes.shape({
      username: PropTypes.string
    })
  }).isRequired
};
export { Footer as TestFooter };
export default entityComposition(Footer, ['login']);